var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecklistIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3555 1.84961C12.1023 1.84965 12.8185 2.14677 13.3467 2.6748C13.8749 3.20303 14.1719 3.91997 14.1719 4.66699V11.5811C14.1719 12.3281 13.8749 13.045 13.3467 13.5732C12.8185 14.1013 12.1023 14.3984 11.3555 14.3984H4.66699C3.91998 14.3984 3.20303 14.1015 2.6748 13.5732C2.14658 13.045 1.84961 12.3281 1.84961 11.5811V4.66699C1.84961 3.91997 2.14658 3.20303 2.6748 2.6748C3.20303 2.14658 3.91997 1.84961 4.66699 1.84961H11.3555ZM4.66699 3.15039C4.26475 3.15039 3.87818 3.30932 3.59375 3.59375C3.30932 3.87818 3.15039 4.26475 3.15039 4.66699V11.5811C3.15039 11.9831 3.30961 12.3689 3.59375 12.6533C3.87818 12.9378 4.26475 13.0977 4.66699 13.0977H11.3555C11.7577 13.0976 12.1433 12.9377 12.4277 12.6533C12.712 12.3689 12.8721 11.9832 12.8721 11.5811V4.66699C12.8721 4.26475 12.7122 3.87818 12.4277 3.59375C12.1434 3.30951 11.7575 3.15043 11.3555 3.15039H4.66699Z",
    fill: "currentFill",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.561 9.82735C8.16945 10.3543 7.38497 10.3674 6.97604 9.8538L5.92168 8.52959C5.70724 8.26028 5.80238 7.86121 6.11525 7.71759C6.3419 7.61356 6.61042 7.68157 6.76022 7.88096L7.02764 8.23689C7.41487 8.75231 8.18145 8.77204 8.59469 8.27722L10.2213 6.32951C10.3671 6.15483 10.6333 6.14817 10.7877 6.31534C10.9108 6.44858 10.9216 6.65058 10.8134 6.79618L8.561 9.82735Z",
    fill: "currentFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistIcon);
export default __webpack_public_path__ + "static/media/ChecklistIcon.f1d3b4fd893f0af2fba9684b4280a122.svg";
export { ForwardRef as ReactComponent };